import { getStore } from './store/store';

export function showAuthModalDialog(): boolean {
    return getStore().shouldShowModalDialog;
}
